import UIkit from 'uikit';
// import Icons from 'uikit/dist/js/uikit-icons';

// loads the Icon plugin
// UIkit.use(Icons);

import './uikit.scss';

export default UIkit;